import { render, staticRenderFns } from "./serveMsg.vue?vue&type=template&id=4e2eecb2&scoped=true&"
import script from "./serveMsg.vue?vue&type=script&lang=js&"
export * from "./serveMsg.vue?vue&type=script&lang=js&"
import style0 from "./serveMsg.vue?vue&type=style&index=0&id=4e2eecb2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2eecb2",
  null
  
)

export default component.exports